import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import{LoopBackAuth, listadosService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';

@Component({
  selector: 'form-asignatura-area',
  templateUrl: './form-asignatura-area.component.html',
  providers:[LoopBackAuth, listadosService, MessageService]
})
export class FormAsignaturaAreaComponent implements OnInit {
  @Input() asignaturaArea : FormGroup
  @Input() activar : boolean = true
  estados: any[]
  ordenes: any []
  constructor(
    private listadosService: listadosService,
    
  ) { }

  ngOnInit() {
    this.onGetOrden()
    this.listadosService.estados().subscribe(lista => this.estados = lista.filter(item => item.id == 0 || item.id == 1))
  }

  onGetOrden(){
    this.ordenes = []
    for(let i = 1; i <= 100; i++){
      this.ordenes.push({
        id: i,
        descripcion: i
      })
      
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/form-asignatura-area.component.ts